import { Combobox } from '../../components/Combobox';
import type { ComboboxOption } from '../../components/combobox-model';
import type { CuratorVenue } from '../../api/curator';
import { formatDateTimeMsk } from '../dashboard/format';
import {
  ALL_VENUES_VALUE,
  freshnessLine,
  venueOptionLabel,
  venueSelectionParam,
  type VenueSelection,
} from './cabinet-model';

/**
 * The scope picker both cabinet surfaces share (T.Z60): the cabinet's tables and the
 * «Группы» page's group list are venue-scoped the same way — «Все места» (the whole
 * scope) or one venue — and the choice travels in the page's own `?venueId=` param.
 * Moved out of `CabinetPage` in T.Z60 unchanged (same testid `cabinet-venue`, same
 * options, same freshness hint), so the two pages cannot drift.
 */
export function VenuePicker({
  venues,
  selection,
  onChange,
}: {
  venues: readonly CuratorVenue[];
  selection: VenueSelection;
  /** The raw picker value: `'all'`, a venue id, or `''` (the × — the first venue). */
  onChange: (raw: string) => void;
}) {
  const options: ComboboxOption[] = [
    {
      value: ALL_VENUES_VALUE,
      label: 'Все места',
      hint: venues.length === 1 ? undefined : `сводка по всем ${venues.length} площадкам`,
    },
    ...venues.map((venue) => {
      const { label, hint } = venueOptionLabel(venue);
      return { value: String(venue.venueId), label, hint };
    }),
  ];
  const current =
    selection.kind === 'venue' ? venues.find((venue) => venue.venueId === selection.venueId) : undefined;

  return (
    <div className="cabinet-toolbar__venue">
      <label className="toolbar__label" htmlFor="cabinet-venue">
        Филиал / площадка
      </label>
      <Combobox
        id="cabinet-venue"
        testId="cabinet-venue"
        value={venueSelectionParam(selection)}
        options={options}
        onChange={onChange}
        ariaLabel="Филиал или площадка"
        placeholder="Выберите площадку"
        clearLabel="Первая площадка из списка"
      />
      {current !== undefined ? (
        <p className="cabinet-toolbar__hint">{freshnessLine(current, formatDateTimeMsk)}</p>
      ) : null}
    </div>
  );
}
